export default (theme) => ({
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
    },
    figure: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        aspectRatio: 1.88,
        margin: '0 0 16px',
        '& > img': {
            display: 'block',
            width: '100%',
            height: '100%',
            objectFit: 'contain',
        },
    },
    list: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
    },
    listItem: {
        margin: 0,
        padding: '0 0 4px 32px',
        position: 'relative',
        '&:not(:last-child)::after': {
            content: '""',
            display: 'block',
            borderLeft: `1px dashed ${theme.colors.grey[100]}`,
            height: '100%',
            width: 0,
            position: 'absolute',
            left: 12,
            top: 0,
            zIndex: 0,
        },
    },
    listItemActive: {
        paddingBottom: 16,
    },
    bullet: {
        position: 'absolute',
        top: -2,
        left: 0,
        zIndex: 1,
    },
    bulletNumber: {
        top: 0,
        left: 2,
        width: 20,
        height: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.colors.grey[50],
        borderRadius: 10,
    },
});
